import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldCheck, HeartHandshake } from 'lucide-react';
export function Solution() {
  const pillars = [{
    icon: <Clock className="w-8 h-8 text-blue-500" data-id="element-239" />,
    title: 'RECUPERÁS TU TIEMPO',
    description: 'Entrás al consultorio con claridad absoluta. Los informes ya tienen la estructura que las prepagas exigen. El material de screening ya está impreso. Las guías para padres ya están listas para entregar. Solo abrís, completás los datos y firmás.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-blue-500" data-id="element-240" />,
    title: 'BLINDÁS TU CONSULTORIO LEGALMENTE',
    description: 'Consentimientos informados actualizados según la Ley 26.529 y la Ley de Salud Mental 26.657. Protocolos de comunicación que establecen límites claros sin perder la calidez médica. Porque un consultorio sin papeles firmados es un consultorio expuesto.'
  }, {
    icon: <HeartHandshake className="w-8 h-8 text-blue-500" data-id="element-241" />,
    title: 'FIDELIZÁS A LAS FAMILIAS',
    description: 'Entregás una Hoja de Ruta de 30 días con tareas semanales para casa y un Tracker Semáforo de progreso. Las familias dejan de sentir que "no saben qué hacer" y empiezan a traerte datos en lugar de preguntas. La adherencia al tratamiento sube. La fuga de pacientes baja.'
  }];
  return <section className="py-20 bg-[#0B1426]" data-id="element-242">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-244">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-245">
            UN SISTEMA QUE TRABAJA CUANDO VOS YA TERMINASTE
          </h2>
          <p className="text-xl text-yellow-500 font-bold mb-6" data-id="element-246">
            MEGA KIT NEURO-PRO™
          </p>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-247">
            Desarrollamos el primer sistema integral de productividad clínica
            para neurólogos y psiquiatras que atienden TDAH y TEA en Argentina.
            Para que dejes de ser el "armador" y empieces a ser el "decisor".
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-248">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-[#111827] border border-gray-800 rounded-2xl p-8 hover:border-blue-500/30 transition-colors" data-id="element-249">
              <div className="w-16 h-16 bg-[#1a2332] rounded-xl flex items-center justify-center mb-6" data-id="element-250">
                {pillar.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-251">
                {pillar.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-252">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}